import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { CoreConfigService } from '@core/services/config.service';
import { ApiService } from 'app/main/services/Api/api.service';
import { HttpErrorResponse } from '@angular/common/http';
import { jwtDecode } from 'jwt-decode';

@Component({
  selector: 'app-auth-login-v2',
  templateUrl: './auth-login-v2.component.html',
  styleUrls: ['./auth-login-v2.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AuthLoginV2Component implements OnInit {
  //  Public
  public coreConfig: any;
  public loginForm: UntypedFormGroup;
  public loading = false;
  public showAlert = false;
  public submitted = false;
  public returnUrl: string;
  public error = '';
  public passwordTextType: boolean;

  // Private
  private _unsubscribeAll: Subject<any>;

  /**
   * Constructor
   *
   * @param {CoreConfigService} _coreConfigService
   */
  constructor(
    private _coreConfigService: CoreConfigService,
    private _formBuilder: UntypedFormBuilder,
    private _route: ActivatedRoute,
    private _router: Router,
    private api: ApiService
  ) {
    this._unsubscribeAll = new Subject();

    // Configure the layout
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true
        },
        menu: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        customizer: false,
        enableLocalStorage: false
      }
    };
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.loginForm.controls;
  }

  /**
   * Toggle password
   */
  togglePasswordTextType() {
    this.passwordTextType = !this.passwordTextType;
  }

  msg: any
  successOrError: boolean = false
  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
    }
    // Login
    this.loading = true;
    

    this.api.Login(this.loginForm.value).subscribe({
      next: (response) => {
        // console.log(response)
        if(response.success == true){
          const token = response.data.accessToken;
          const data = jwtDecode(token);
          const user = JSON.parse(JSON.stringify(data));
          const role = user.role || user['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] || '';
          if(role == 'Admin' || role == 'Assistant' || role == 'Organizer'){
            this.showAlert = true;
            this.successOrError = true;
            this.msg = response.message;
            localStorage.setItem('b2b_token', token);
            localStorage.setItem('b2b_user_data', JSON.stringify(data));
            const username = user.unique_name || user['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'] || user.given_name || '';
            localStorage.setItem('b2b_username', username);
            const exp = user.exp ? user.exp.toString() : '';
            localStorage.setItem('b2b_exp', exp);
            localStorage.setItem('b2b_role', role);
            setTimeout(() => {
              this.loading = false
              this.showAlert = false
              // this._router.navigate(['/home']);
              window.location.href = '/home';
            }, 5000);
          }else{
            this.showAlert = true;
            this.successOrError = false
            this.msg = 'اسم المستخدم أو كلمة المرور غير صالحة'
            this.loading = false
            setTimeout(() => {
              this.showAlert = false
            }, 5000);
          }
        }else{
          this.showAlert = true;
          this.successOrError = false
          this.msg = 'اسم المستخدم أو كلمة المرور غير صالحة'
          this.loading = false
          setTimeout(() => {
            this.showAlert = false
          }, 5000);
        }
      },error: (error: HttpErrorResponse) => {
        this.showAlert = true;
        this.successOrError = false
        console.log(error.error.message)
        this.msg = error.error.message
        this.loading = false
        setTimeout(() => {
          this.showAlert = false
        }, 5000);
      }
    })
    // redirect to home page
  }

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    this.loginForm = this._formBuilder.group({
      userNameOrPhoneNumber: ['', [Validators.required]],
      password: ['', Validators.required]
    });

    // get return url from route parameters or default to '/'
    this.returnUrl = this._route.snapshot.queryParams['returnUrl'] || '/';

    // Subscribe to config changes
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
      this.coreConfig = config;
    });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
}
